import React from 'react';
import PropTypes from 'prop-types';
import { InputField, ErrorMessage } from 'anf-core-react';

function AddressInput({
  name,
  value,
  label,
  placeholder,
  type,
  maxLength,
  onChange,
  onBlur,
  error,
  errorMessage,
  hasValidationError,
  isInvalid,
  isRequired,
  isDisabled,
}) {
  // Extract label text from either string or object format
  const labelText = typeof label === 'string' ? label : label?.value || '';

  // Extract error text from either string or object format
  const errorText = error?.value || errorMessage || '';

  // Determine if field is invalid
  const fieldIsInvalid = isInvalid || hasValidationError;

  const id = `address-input-${name}`;

  return (
    <InputField
      id={id}
      name={name}
      value={value || ''}
      label={labelText}
      placeholder={placeholder}
      type={type}
      maxLength={maxLength}
      onChange={onChange}
      onBlur={onBlur}
      isInvalid={fieldIsInvalid}
      isRequired={isRequired}
      isDisabled={isDisabled}
      autoComplete="off"
    >
      {fieldIsInvalid && errorText && (
        <ErrorMessage>
          {errorText}
        </ErrorMessage>
      )}
    </InputField>
  );
}

AddressInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      key: PropTypes.string,
      value: PropTypes.string,
    }),
  ]).isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  maxLength: PropTypes.number,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  error: PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  }),
  errorMessage: PropTypes.string,
  hasValidationError: PropTypes.bool,
  isInvalid: PropTypes.bool,
  isRequired: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

AddressInput.defaultProps = {
  value: '',
  placeholder: '',
  type: 'text',
  maxLength: 255,
  onChange: () => {},
  onBlur: () => {},
  error: null,
  errorMessage: '',
  hasValidationError: false,
  isInvalid: false,
  isRequired: false,
  isDisabled: false,
};

export default AddressInput;
